import { Branding } from "./branding";
import { Constraint } from "./constraint";
import { Contributor } from "./contributor";
import { ImageCreateDate } from "./imageCreateDate";

export class Asset {
    AssetCount: number;
    Assets: any;
    AdditionalMetadata: any;
    Albums: any;
    AlternateTitles: any;
    AltText: any;
    AssetBaseType: string;
    AssetID: string;
    AssetProperties: any;
    AssetType: string;
    Brandings: Branding[];
    Categories: any;
    Collector: any;
    Comment: any;
    ConstraintsInformation: Constraint;
    Contacts: any;
    Contributors: Contributor[];
    ControlledKeywords: any;
    Copyright: string;
    CustomTextFields: any;
    CustomNumberFields: any;
    Description: string;
    Downloads: any;
    FileInfo: any;
    FormatDescription: any;
    Groups: any;
    ImageContentDate: any;
    ImageCreateDate: ImageCreateDate;
    ImageCreateDateTime: Date;
    ImageDetails: any;
    IntendedAudience: any;
    Keywords: any;
    LastEditDateTime: Date;
    Locations: any;
    NPSOnlyComments: any;
    NPSUnits: any;
    OnlineLinkages: any;
    OriginalFileName: any;
    PhotoCredit: any;
    PrimaryType: any;
    Publisher: string;
    Rating: any;
    RelatedCollections: any;
    RelatedResources: any;
    RelatedSystems: any;
    RetentionDescription: any;
    RetentionPeriod: any;
    ResourceFormat: any;
    ResourceType: string;
    SourceInformationDescription: any;
    SourceLanguage: any;
    SourceLocation: any;
    SourceProvenance: any;
    Subject: string;
    SubmittedDateTime: Date;
    Submitter: any;
    SubType: any;
    TableOfContents: any;
    Title: string;
    TicParentDocID: string;
    TicNumber: string;
    TicParkAlpha: string;
    TicLocation: string;
    TicInfoType: string;
    TicParentName: string;
}  

export class Records {
  Results: Record[];
}

export class Record {
    ticParentDocId: number;
    ticParkAlpha: string;
    ticParkId: number;
    ticParkName: string;
    ticDocType: string;
    ticDocTypeId: number;
    ticCorpAuthor: string;
    ticEticAdded: boolean;
    ticFrcAccessionNumber: string;
    ticFrcBox: string;
    ticInfoDate: string;
    ticInfoType: string;
    ticLitigationHold: boolean;
    ticLocation: string;
    ticMedia: string;
    ticMicrofilmMissing: number;
    ticModifiedDate: Date;
    ticOriginalMissing: number;
    ticOriginSystem: string;
    ticParentName: string;
    ticPdfMergeDate: Date;
    ticPublishDate: Date;
    ticRetentionCategory: string;
    ticRetentionDisposition: string;
    ticSecurityVerification: boolean;
    ticSize: string;
    ticStorage: string;
    ticSubject: string;
    ticNumber: string;
    AssetCount: number;
    IsLocked: boolean;
    AltText: string;
    AssetID: string;
    AssetStatus: string;
    // ConstraintsInformation: {
    //     Constraint: Public domain,
    //     GrantingRights: Unknown
    // },
    Copyright: string;
    Editable: boolean;
    LastEditDateTime: Date;
    Publisher: string;
    Rating: number;
    ResourceType: string;
    
    Subject: string;
    SubmittedDateTime: Date;
    Submitter: string;
    Title: string;
    ticRevisionCode: string;
    ticDupeCode: string;
}